export const STR_APP_NAME = {
  en: "Afya Mingle",
  sw: "Afya Mingle",
};

export const STR_HEALTH = {
  en: "health",
  sw: "afya",
}

export const STR_RELATIONSHIPS = {
  en: "relationships",
  sw: "mahusiano",
}

export const STR_DOCTORS = {
  en: "Doctors",
  sw: "Madaktari",
}

export const STR_HEALTH_TIPS = {
  en: "Health Tips",
  sw: "Dondoo za Afya",
}

export const STR_STORIES = {
  en: "stories",
  sw: "masimulizi",
}

export const STR_GET_STARTED = {
  en: "get started",
  sw: "anza sasa",
}

export const STR_CONTINUE = {
  en: "continue",
  sw: "endelea",
}

export const STR_ENTER = {
  en: "enter",
  sw: "ingia",
}

export const STR_ENTER_YOUR_PHONE_NUMBER = {
  en: "Enter your phone number",
  sw: "Ingiza namba yako ya simu",
}

export const STR_PHONE_NUMBER = {
  en: "Phone number",
  sw: "Namba ya simu",
}

export const STR_ENTER_OTP = {
  en: "Enter the OTP sent to your phone",
  sw: "Ingiza OTP uliotumiwa kwenye simu",
}

export const STR_PLEASE_WAIT = {
  en: "Please wait..",
  sw: "Tafadhali subiri..",
}

export const STR_INVALID_PHONE = {
  en: "Invalid phone number",
  sw: "Namba ya simu sio sahihi",
}

export const STR_INVALID_OTP = {
  en: "Invalid OTP",
  sw: "OTP sio sahihi",
}

export const STR_WELCOME = {
  en: "Welcome..",
  sw: "Karibu..",
}

export const STR_CHANGE_PHONE = {
  en: "Change Phone",
  sw: "Badili Simu",
}

export const STR_RESEND_OTP = {
  en: "Resend OTP",
  sw: "Tuma tena OTP",
}

export const STR_MENU_HOME = {
  en: "Home",
  sw: "Nyumbani",
}

export const STR_MENU_DATING = {
  en: "Dating",
  sw: "Mahusiano",
}

export const STR_MENU_DOCTORS = {
  en: "Doctors",
  sw: "Madaktari",
}

export const STR_MENU_INBOX = {
  en: "Inbox",
  sw: "Ujumbe",
}

export const STR_MENU_ARTICLES = {
  en: "Articles",
  sw: "Makala",
}

export const STR_MENU_STORIES = {
  en: "Stories",
  sw: "Simulizi",
}

export const STR_MENU_UTILITIES = {
  en: "Utilities",
  sw: "Visaidizi",
}

export const STR_LATEST_ARTICLES = {
  en: "Latest Articles",
  sw: "Makala Mpya",
}

export const STR_MORE_ARTICLES = {
  en: "More Articles",
  sw: "Makala Zaidi",
}

export const STR_LATEST_STORIES = {
  en: "Latest Stories",
  sw: "Simulizi Mpya",
}

export const STR_MORE_STORIES = {
  en: "More Stories",
  sw: "Simulizi Zaidi",
}

export const STR_PERSONAL_SETTINGS = {
  en: "Personal Settings",
  sw: "Mipangilio Binafsi",
}

export const STR_UPDATE_USERNAME = {
  en: "Update username",
  sw: "Badili/Weka jina",
}

export const STR_CHANGE_PHONE_NUMBER = {
  en: "Change phone number",
  sw: "Badili namba ya simu",
}

export const STR_UPDATE_PERSONAL_INFO = {
  en: "Update personal information",
  sw: "Badili/Weka taarifa binafsi",
}

export const STR_PAYMENT_SETTINGS = {
  en: "Payments",
  sw: "Malipo",
}

export const STR_SUBSCRIPTION_FEE_PAYMENTS = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_CONSULTATION_FEE_PAYMENTS = {
  en: "Doctor's consultation fee payment",
  sw: "Malipo ya kuwasiliana na daktari",
}

export const STR_MY_SUBSCRIPTION = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_SUBSCRIPTION_HAS_EXPIRED = {
  en: "Subscription has expired",
  sw: "Kifurushi kimeisha",
}

export const STR_PURCHASE_SUBSCRIPTION_PACKAGE = {
  en: "Purchase a subscription package to view all content in this app",
  sw: "Nunua kifurushi cha matumizi ili kuona kila kitu ndani ya App",
}

export const STR_SELECT = {
  en: "Select",
  sw: "Chagua",
}

export const STR_COMPLETE_PAYMENT = {
  en: "Complete Payment",
  sw: "Kamilisha Malipo",
}

export const STR_PAY_WITH_CARD = {
  en: "Pay with Credit Card",
  sw: "Lipia kwa Kadi",
}

export const STR_PAY_WITH_MOBILE = {
  en: "Pay with Mobile Network",
  sw: "Lipia kwa Mtandao wa Simu",
}

export const STR_SELECT_PAYMENT_METHOD = {
  en: "Select payment method",
  sw: "Chagua njia ya kufanya malipo",
}

export const STR_ENTER_PHONE_NUMBER_FOR_PAYMENT = {
  en: "Enter phone number you want to use for this payment. All Tanzanian networks are supported.",
  sw: "Ingiza namba ya simu utakayofanyia malipo. Tunapokea kutoka mitandao yote ya Tanzania",
}

export const STR_FINALIZE_PAYMENT_CARD = {
  en: "Please wait, you'll soon be redirected to complete the payment with your card.",
  sw: "Tafadhali subiri utaelekezwa kwenye kiungo cha kufanyia malipo kwa kadi yako",
}

export const STR_FINALIZE_PAYMENT_MOBILE = {
  en: "Push USSD was sent to your phone please check and finalize the payment",
  sw: "Tafadhali angalia simu yako ili kukamilisha malipo kwa USSD Push",
}

export const STR_BUY_NOW = {
  en: "Buy Now",
  sw: "Nunua Sasa",
}

export const STR_DAYS = {
  en: "Days",
  sw: "Siku",
}

export const STR_FROM = {
  en: "From",
  sw: "Kuanzia",
}

export const STR_TO = {
  en: "To",
  sw: "Hadi",
}

export const STR_PRICE = {
  en: "Price",
  sw: "Bei",
}

export const STR_FIND_MATCH = {
  en: "Find a Match",
  sw: "Tafuta Mchumba",
}

export const STR_TITLE_FIND_MATCH = {
  en: "Find a Match",
  sw: "Tafuta Mchumba",
}

export const STR_USERNAME = {
  en: "Username",
  sw: "Jina",
}

export const STR_GENDER = {
  en: "Your Gender",
  sw: "Jinsia yako",
}

export const STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO = {
  en: "Please update your personal information",
  sw: "Tafadhali weka taarifa zako binafsi",
}

export const STR_SUBMIT = {
  en: "Submit",
  sw: "Wasilisha",
}

export const STR_MALE = {
  en: "Male",
  sw: "Mwanaume",
}

export const STR_FEMALE = {
  en: "Female",
  sw: "Mwanamke",
}

export const STR_INVALID_USERNAME = {
  en: "Invalid username",
  sw: "Jina sio sahihi",
}

export const STR_INVALID_GENDER = {
  en: "Invalid gender",
  sw: "Jinsia sio sahihi",
}

export const STR_SUCCESS = {
  en: "Successful...",
  sw: "Imefanikiwa...",
}

export const STR_DESCRIPTION = {
  en: "Description",
  sw: "Maelezo",
}

export const STR_REGION = {
  en: "Region",
  sw: "Mkoa",
}

export const STR_DISTRICT = {
  en: "District",
  sw: "Wilaya",
}

export const STR_INVALID_DESCRIPTION = {
  en: "Invalid description",
  sw: "Maelezo sio sahihi",
}

export const STR_INVALID_REGION = {
  en: "Invalid region",
  sw: "Mkoa sio sahihi",
}

export const STR_INVALID_DISTRICT = {
  en: "Invalid district",
  sw: "Wilaya sio sahihi",
}

export const STR_NO_DATA_FOUND = {
  en: "No data was found",
  sw: "Hakuna taarifa kwa sasa",
}

export const STR_NO_CHAT_WAS_FOUND = {
  en: "No chat was found",
  sw: "Hakuna chat kwa sasa",
}

export const STR_START_CHAT_WITH_MEMBER = {
  en: "Start a chat with this user",
  sw: "Anzisha chat na mtumiaji huyu",
}

export const STR_YES = {
  en: "Yes",
  sw: "Ndio",
}

export const STR_NO = {
  en: "No",
  sw: "Hapana",
}

export const STR_NO_MESSAGES = {
  en: "No messages",
  sw: "Hakuna ujumbe kwa sasa",
}

export const STR_NO_DOCTORS = {
  en: "No doctors were found",
  sw: "Hakuna madaktari kwa sasa",
}

export const STR_PER_SESSION = {
  en: "Per session (24 hours)",
  sw: "Kwa session (Masaa 24)",
}

export const STR_START_CHAT = {
  en: "Start Chat",
  sw: "Anzisha Chat",
}

export const STR_PAY_NOW = {
  en: "Pay Now",
  sw: "Lipia Sasa",
}

export const STR_MENU_DOCTOR_ROOMS = {
  en: "Doctors",
  sw: "Madaktari",
}

export const STR_MENU_CHAT_ROOMS = {
  en: "Dating",
  sw: "Mahusiano",
}

export const STR_SEARCH_HERE = {
  en: "Search here...",
  sw: "Tafuta hapa",
}

export const STR_ALL = {
  en: "All",
  sw: "Zote",
}

export const STR_SEND = {
  en: "Send",
  sw: "Tuma",
}

export const STR_CANCEL = {
  en: "Cancel",
  sw: "Ghairi",
}

export const STR_CLICK_TO_PICK_IMAGE = {
  en: "Click below to select image",
  sw: "Bonyeza hapo chini kuchagua picha",
}

export const STR_IMAGE = {
  en: "Image",
  sw: "Picha",
}

export const STR_NOTIFICATIONS = {
  en: "Notifications",
  sw: "Taarifa",
}

export const STR_OPEN = {
  en: "Open",
  sw: "Fungua",
}

export const STR_CHANGE_THEME = {
  en: "Change Theme",
  sw: "Badili Rangi",
}

export const STR_LOGOUT = {
  en: "Log Out",
  sw: "Ondoka kwenye Akaunti",
}

export const STR_INVALID_EMAIL = {
  en: "Invalid email",
  sw: "Anwani ya barua pepe sio sahihi",
}

export const STR_INVALID_CONFIRM_PASSWORD = {
  en: "Please confirm your password correctly",
  sw: "Tafadhali hakiki nenosiri lako kwa usahihi",
}

export const STR_INVALID_PASSWORD = {
  en: "Invalid Password, password must have atleast 6 characters",
  sw: "Nenosiri angalau liwe na muunganiko wa namba na herufi angalau 6",
}

export const STR_ENTER_EMAIL_ADDRESS = {
  en: "Enter your email address",
  sw: "Weka anwani yako ya barua pepe",
}

export const STR_CHANGE_LANGUAGE = {
  en: "Tumia Swahili",
  sw: "Change to English",
}

export const STR_PASSWORD = {
  en: "Password",
  sw: "Nenosiri",
}

export const STR_CONFIRM = {
  en: "Confirm",
  sw: "Hakiki",
}

export const STR_CHANGE = {
  en: "Change",
  sw: "Badili",
}

export const STR_FORGOT_PASSWORD = {
  en: "Forgot Password",
  sw: "Nimesahau Nenosiri",
}

export const STR_CONTACT_US = {
  en: "Contact us",
  sw: "Wasiliana nasi",
}


export const STR_VIEW_MORE = {
  en: "View More...",
  sw: "Ona Zaidi...",
}

export const STR_COMMENTS = {
  en: "Comments",
  sw: "Maoni",
}

export const STR_WRITE_YOUR_COMMENT = {
  en: "Write your comment",
  sw: "Andika maoni yako",
}

export const STR_NO_COMMENTS = {
  en: "No comments yet",
  sw: "Hakuna maoni kwa sasa",
}

export const STR_INVALID_COMMENT = {
  en: "Invalid comment",
  sw: "Maoni sio sahihi",
}

export const STR_CLICK_TO_VIEW_COMMENTS = {
  en: "Write or View Comments",
  sw: "Andika au Ona Maoni",
}

export const STR_PHARMACY = {
  en: "Pharmacy",
  sw: "Pharmacy",
}

export const STR_VIDEOS = {
  en: "Videos",
  sw: "Videos",
}

export const STR_SHORTS = {
  en: "Shorts",
  sw: "Shorts",
}

export const STR_CONFESSIONS = {
  en: "Confessions",
  sw: "Confessions",
}

export const STR_YOUR_PHOTO = {
  en: "Your Photo",
  sw: "Picha yako",
}

export const STR_OPTIONAL = {
  en: "Optional",
  sw: "Sio lazima",
}

export const STR_CHAT_NOW = {
  en: "Chat Now",
  sw: "Chat Nae",
}

export const STR_COMING_SOON = {
  en: "Coming Soon",
  sw: "Inakujia Hivi Karibuni",
}

export const STR_RECEIVE_OTP_VIA_SMS = {
  en: "Receive OTP via SMS",
  sw: "Pokea OTP kupitia SMS",
}

export const STR_RECEIVE_OTP_VIA_WHATSAPP = {
  en: "Receive OTP via WhatsApp",
  sw: "Pokea OTP kupitia WhatsApp",
}
export const STR_OR = {
  en: "Or",
  sw: "Au",
}

export const STR_VIEW_MORE_HEALTH_TIPS = {
  en: "CLick here for more Health Tips...",
  sw: "Bofya hapa kwa Dondoo zaidi za afya...",
}

export const STR_FITNESS = {
  en: "Fitness Zone",
  sw: "Fitness Zone",
}

export const STR_CHITCHAT = {
  en: "ChitChat & Podcasts",
  sw: "Soga na Podcasts",
}

export const STR_TAB_SHOP = {
  en: "Shop",
  sw: "Duka",
}

export const STR_TAB_MY_ORDERS = {
  en: "My Orders",
  sw: "Oda zangu",
}

export const STR_SHOP_INTRO_1 = {
  en: "Supplements, Health devices and kits",
  sw: "Virutubisho na vifaa tiba",
}

export const STR_CART_WAS_UPDATED = {
  en: "Cart was Updated",
  sw: "Kapu lako limerekebishwa",
}

export const STR_SHOP_BUY_NOW = {
  en: "Buy Now",
  sw: "Nunua Sasa",
}

export const STR_COULD_NOT_FETCH_DATA = {
  en: "Could not fetch data, check your network",
  sw: "Imeshindwa kupakia data, angalia mtandao wako",
}

export const STR_PLEASE_SELECT_ITEMS_TO_BUY = {
  en: "Please select items to purchase",
  sw: "Tafadhali chagua bidhaa za kununua",
}

export const STR_PROVIDE_YOUR_ADDRESS = {
  en: "Tell us where you are",
  sw: "Tujulishe ulipo",
}

export const STR_WARD = {
  en: "Ward or Village",
  sw: "Kata au Kijiji",
}

export const STR_STREET = {
  en: "Street",
  sw: "Mtaa",
}

export const STR_TOTAL_ORDER_PRICE = {
  en: "Total items' price",
  sw: "Jumla ya bei za bidhaa",
}

export const STR_SHIPPING_COST = {
  en: "Shipping Cost",
  sw: "Gharama za usafirishaji",
}

export const STR_TRANSACTION_FEES = {
  en: "Transaction fees",
  sw: "Tozo za muamala",
}

export const STR_OVERALL_COST = {
  en: "Overall Cost",
  sw: "Jumla kuu",
}

export const STR_PAY_TO_PLACE_ORDER = {
  en: "Pay Now and Place Order",
  sw: "Lipia Sasa na Uweke Oda",
}

export const STR_ORDER_NOTES = {
  en: "Order notes",
  sw: "Maelekezo kuhusu oda hii",
}

export const STR_ORDER_NOTES_HELP_TEXT = {
  en: "Do you have any instruction about this order? Write here",
  sw: "Je ungependa kuacha maelekezo yoyote kuhusu oda hii? Tuandikie hapa",
}

export const STR_ENTER_PAYPHONE = {
  en: "Enter Phone number you'll use to complete payment",
  sw: "Ingiza namba ya simu utakayotumia kufanya malipo",
}

export const STR_PHARMACY_ORDER_FINAL_TEXT_PHONE = {
  en: "Thanks for placing your order, we have pushed a USSD notification for you to complete the payment",
  sw: "Asante kwa kuweka oda, tumetuma USSD push kwenye simu yako kwa ajili ya kufanya malipo",
}

export const STR_PHARMACY_ORDER_FINAL_TEXT_CARD = {
  en: "Thanks for placing your order, you'll be redirected to a payment gateway shortly.",
  sw: "Asante kwa kuweka oda, utaelekezwa hivi punde kwenye kiungo cha kufanyia malipo.",
}

export const STR_GO_BACK = {
  en: "Back",
  sw: "Rudi",
}

export const STR_YOUR_CART = {
  en: "Your Cart",
  sw: "Kapu Lako",
}

export const STR_PLACE_ORDER = {
  en: "Place Order",
  sw: "Weka Oda",
}

export const STR_CLICK_HERE_FOR_MORE_CONFESSIONS = {
  en: "Click here for more Confessions...",
  sw: "Bofya hapa kusoma Confessions zaidi..",
}

export const STR_COMING_SOON_2 = {
  en: "Coming Soon. Stay Tuned!",
  sw: "Inakujia hivi karibuni!",
}

export const STR_DOCTORS_2 = {
  en: "Doctors and Health Personnel",
  sw: "Madaktari na Wahudumu wa Afya",
}

export const STR_EXTRAS = {
  en: "Extras..",
  sw: "Zaidi..",
}

export const STR_ORDERED_ITEMS = {
  en: "Ordered Items",
  sw: "Bidhaa zilizoagizwa",
}

export const STR_IS_PAID = {
  en: "Is Paid?",
  sw: "Imelipiwa?",
}

export const STR_IS_CANCELLED = {
  en: "Is Cancelled?",
  sw: "Imesitishwa?",
}

export const STR_IS_DELIVERED = {
  en: "Is Delivered?",
  sw: "Imefikishwa?",
}

export const STR_IS_SHIPPED = {
  en: "Is Shipped?",
  sw: "Imesafirishwa?",
}

export const STR_CANCEL_ORDER = {
  en: "Cancel this order",
  sw: "Sitisha Oda",
}

export const STR_MAKE_PAYMENT = {
  en: "Make Payment",
  sw: "Fanya Malipo",
}

export const STR_ALREADY_PAID = {
  en: "Already Paid",
  sw: "Imeshalipiwa",
}

export const STR_ALREADY_CANCELLED = {
  en: "Already Cancelled",
  sw: "Imesitishwa",
}

export const STR_CART_IS_EMPTY = {
  en: "Cart is empty, add items to cart from our pharmacy",
  sw: "Kapu lipo tupu, tembelea pharmacy kuweka bidhaa kwenye kapu",
}

export const STR_ = {
  en: "",
  sw: "",
}



